import type { State } from 'model/State';

export const selectPartnerWhitelistStatus = (state: State) =>
  state.mac.partnerMigration?.partnerWhitelistStatus?.ifSuccess((r) => r);
